import React, { useState, useEffect, useRef } from "react";

import Navigation from "../Navigation/Navigation";
import classes from "./MainHeader.module.css";
import tt_logo from "../../assets/images/tt_logo.jpg";
import classNames from "classnames";
import MobileNavLinks, { MOBILE_NAV_ID } from "../MobileNavigation/MobileNavLinks";

import "../../styles.scss";

import { NavLink } from "react-router-dom";
import Buttons from "../Buttons/Buttons";

const MainHeader = (props) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const menuButtonRef = useRef(null);
  const mobileNavRef = useRef(null);
  const active = classNames("mobile-menu", {
    open: mobileNavOpen,
  });

  //Start closed the next time the mobile layout is shown.
  useEffect(() => {
    if (!props.showMobileNavMenu) setMobileNavOpen(false);
  }, [props.showMobileNavMenu]);

  function closeMobileNav(returnFocus) {
    setMobileNavOpen(false);
    if (returnFocus && menuButtonRef.current !== null) menuButtonRef.current.focus();
  }

  function onMobileNavKeyDown(e) {
    if (e.key === "Escape" && mobileNavOpen) {
      closeMobileNav(true);
    }
  }

  //Closes the menu when focus moves to something outside it, since the open menu covers
  //the buttons below it. relatedTarget is null when focus goes nowhere in particular
  //(Safari doesn't focus links on click), so the menu stays open then.
  function onMobileNavBlur(e) {
    const next = e.relatedTarget;
    const isInsideMenu = (node) =>
      (menuButtonRef.current !== null && menuButtonRef.current.contains(node)) ||
      (mobileNavRef.current !== null && mobileNavRef.current.contains(node));

    if (mobileNavOpen && next !== null && !isInsideMenu(next)) {
      setMobileNavOpen(false);
    }
  }

  return (
    <>
      <header className="navigation-wrapper">
        <div className="navigation-header">
          <div className={classes["container"]}>
            <div className={classes["column"]}>
              <NavLink to="/">
                <img
                  className={classes["img"]}
                  alt="Typer Logo"
                  src={tt_logo}
                ></img>
              </NavLink>
            </div>
            <div>
              <NavLink to="/" className={classes["text"]}>
                Typer Online
              </NavLink>
            </div>
          </div>

          {props.showMobileNavMenu ? (
            <span className="navigation-links">
              <button
                ref={menuButtonRef}
                type="button"
                aria-label="Navigation menu"
                aria-expanded={mobileNavOpen}
                aria-controls={MOBILE_NAV_ID}
                className={active}
                onClick={() => {
                  setMobileNavOpen((mobileNavOpen) => !mobileNavOpen);
                }}
                onKeyDown={onMobileNavKeyDown}
                onBlur={onMobileNavBlur}
              >
                <span className="bar-one" aria-hidden="true" />
                <span className="bar-two" aria-hidden="true" />
                <span className="bar-three" aria-hidden="true" />
              </button>
            </span>
          ) : (
            <>
              <Buttons {...props} />
              <Navigation headerFontSize={props.headerFontSize} />
            </>
          )}
        </div>
      </header>
      {/* The menu comes right after the header so its links directly follow the menu button. */}
      {props.showMobileNavMenu ? (
        <>
          <MobileNavLinks
            navRef={mobileNavRef}
            open={mobileNavOpen}
            onClose={closeMobileNav}
            onKeyDown={onMobileNavKeyDown}
            onBlur={onMobileNavBlur}
          />
          <Buttons {...props} />
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default MainHeader;
